import type { ComponentProps } from "react";
import EventDiaTalk from "./event-diatalk";
import EventTopicTalk from "./event-topictalk";
import EventSprechstunde from "./event-sprechstunde";
import EventCommunity from "./event-community";
import EventReisen from "./event-reisen";

export type EventIconName =
  | "diaTalk"
  | "topicTalk"
  | "sprechstunde"
  | "community"
  | "reisen"
  // Info-Termine *ueber* eine Reise. Eigene Kategorie, weil sie anders als
  // die Reisen selbst kostenlose Online-Events mit Anmeldung sind — optisch
  // gehoeren sie aber zu den Reisen und teilen sich deren Symbol.
  | "reiseInfo";

type EventIconProps = {
  name: EventIconName;
} & ComponentProps<"svg">;

const EventIcon = ({ name, ...props }: EventIconProps) => {
  switch (name) {
    case "diaTalk":
      return <EventDiaTalk {...props} />;
    case "topicTalk":
      return <EventTopicTalk {...props} />;
    case "sprechstunde":
      return <EventSprechstunde {...props} />;
    case "community":
      return <EventCommunity {...props} />;
    case "reisen":
    case "reiseInfo":
      return <EventReisen {...props} />;
  }
};

export { EventIcon };
